export default __webpack_public_path__ + "static/media/16.2b89178f.png";